import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

export function Card({ children, padded = true, className, ...rest }: CardProps) {
  return (
    <div
      className={cn('rounded-xl border border-line bg-surface shadow-card', padded && 'p-5', className)}
      {...rest}
    >
      {children}
    </div>
  );
}
